import { styled as muiStyled } from '@mui/material';

export const StyledForm = muiStyled('form')({
  marginTop: 12,
  marginBottom: 40,
  padding: '0 100px',
});
